import React from "react";
import { connect } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import { PathwayCard, PathwayCardBody } from "../../../_UI/Components/PathwayCard";
import { PathwayButton } from "../../../_UI/Components/PathwayButtons";
import queryString from "query-string";
import AlertComponent from "../../../_UI/Components/Alerts/AlertComponent";
import { lexofficeActions } from "../services/store/lexoffice.actions";
import { logout } from "../../../user/services/store/authentication.actions";
import { PathwayInput } from "../../../_UI/StyledComponents/PathwayForm";

class LexOfficeRegistration extends React.Component {
    static CREATE_MODE = 0;
    static EDIT_MODE = 1;

    constructor(props) {
        super(props);

        this.props.dispatch(logout());

        let params = queryString.parse(this.props.location.search);
        this.state = {
            urlParams: params,
            userData: {
                code: params["code"],
                email: params["mail"] || "",
                password: "",
                passwordRepeat: "",
            },
            submitted: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.register = this.register.bind(this);
    }

    handleChange(e) {
        this.setState({
            userData: {
                ...this.state.userData,
                [e.target.name]: e.target.value,
            },
        });
    }

    register() {
        this.props.dispatch(lexofficeActions.registerOrganization(this.state.userData));
    }

    render() {
        const { lexoffice, userRegistration } = this.props;
        return (
            <div className="app flex-row align-items-center">
                <Container>
                    <Row className="justify-content-center">
                        <Col md="6" xs="12">
                            <div className="card-group">
                                <PathwayCard>
                                    <PathwayCardBody>
                                        <Row>
                                            <Col xs="12" className="justify-content-center">
                                                <img
                                                    src={process.env.PUBLIC_URL + "/logo.png"}
                                                    alt="Pathway Logo"
                                                    style={{ maxWidth: "60%" }}
                                                    className="rounded mx-auto d-block"
                                                />
                                                <br />
                                                <br />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <AlertComponent
                                                    errorMessages={userRegistration.errorMessage}
                                                    warningMessages={userRegistration.warningMessage}
                                                />
                                                <AlertComponent errorMessages={lexoffice.errorMessage} />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <div className="input-group mb-3" style={{ marginTop: "1em" }}>
                                                    <div className="input-group-append">
                                                        <span className="input-group-text">
                                                            <i className="icon-user"></i>
                                                        </span>
                                                    </div>
                                                    <PathwayInput
                                                        type="text"
                                                        disabled={this.state.urlParams["mail"]}
                                                        placeholder="E-Mail"
                                                        name="email"
                                                        value={this.state.userData.email}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                                <div className="input-group mb-4">
                                                    <div className="input-group-append">
                                                        <span className="input-group-text">
                                                            <i className="icon-lock"></i>
                                                        </span>
                                                    </div>
                                                    <PathwayInput
                                                        type="password"
                                                        placeholder="Passwort"
                                                        name="password"
                                                        value={this.state.userData.password}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                                <div className="input-group mb-4">
                                                    <div className="input-group-append">
                                                        <span className="input-group-text">
                                                            <i className="icon-lock"></i>
                                                        </span>
                                                    </div>
                                                    <PathwayInput
                                                        type="password"
                                                        placeholder="Passwort wiederholen"
                                                        name="passwordRepeat"
                                                        value={this.state.userData.passwordRepeat}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                                <Row>
                                                    <Col>
                                                        {lexoffice.loading ? (
                                                            <button
                                                                className="btn btn-primary"
                                                                type="button"
                                                                onClick={this.register}
                                                            >
                                                                <span
                                                                    className="spinner-border spinner-border-sm"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                ></span>{" "}
                                                                Registrieren
                                                            </button>
                                                        ) : (
                                                            <PathwayButton
                                                                color="primary"
                                                                className="px-4"
                                                                onClick={this.register}
                                                            >
                                                                Registrieren
                                                            </PathwayButton>
                                                        )}
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </PathwayCardBody>
                                </PathwayCard>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { loggingIn } = state.authentication;
    const { authentication, client, integrations, userRegistration } = state;
    const { lexoffice } = integrations;
    return {
        loggingIn,
        authentication,
        client,
        lexoffice,
        userRegistration,
    };
}

export default connect(mapStateToProps)(LexOfficeRegistration);
